"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const ModalPageCollapse_1 = __importDefault(require("./ModalPageCollapse"));
const A_1 = __importDefault(require("../components/Util/A"));
const Tooltip_1 = __importDefault(require("../components/Animation/Tooltip"));
const useMountAnimation_1 = __importDefault(require("../hooks/useMountAnimation"));
const helpers_1 = require("../lib/helpers");
const mergeProps_1 = __importDefault(require("../lib/mergeProps"));
const useAddToForwardRef_1 = require("./useAddToForwardRef");
const useOnClickBusy_1 = require("../hooks/useOnClickBusy");
function parsePropsIntoClassName(journeyClassName, props, busy) {
    const { onClick, className: propClassName, testId } = props;
    // journeyClassName first for easy identifying when browsing elements.
    return classnames_1.default(journeyClassName, {
        'cursor-pointer': onClick && journeyClassName !== 'j-button' && journeyClassName !== 'j-back-drop' && !busy,
        [`test-${testId}`]: !!testId,
        busy,
    }, propClassName);
}
function withJourney(compClassName, FunctionalComponent, options = {}) {
    const { collapseInModal, wrapsHref = true, onClickHelper = true } = options;
    const NewComponent = react_1.forwardRef((props, ref) => {
        const tooltipTargetRef = react_1.useRef(null);
        const mountAnimationProps = useMountAnimation_1.default(props);
        const { ref: mountAnimationRef } = mountAnimationProps;
        const { className: classNameFromProps, onClick, href, collapse, disableMount } = props;
        const forwardedRef = useAddToForwardRef_1.useAddToForwardRef(props, [tooltipTargetRef, ref, mountAnimationRef]);
        const { busy, onClick: onClickHandle } = useOnClickBusy_1.useOnClickBusy(onClick, onClickHelper);
        const newProps = Object.assign(Object.assign({}, mergeProps_1.default(Object.assign(Object.assign({}, props), helpers_1.without(mountAnimationProps, ['ref'])))), { forwardedRef });
        /* Only assign onClick busy wrapper if we provide an onClick. */
        if (props.onClick) {
            newProps.onClick = onClickHandle;
        }
        newProps.className = parsePropsIntoClassName(compClassName, newProps, busy);
        if ((classNameFromProps === null || classNameFromProps === void 0 ? void 0 : classNameFromProps.includes('gap-')) && (classNameFromProps === null || classNameFromProps === void 0 ? void 0 : classNameFromProps.includes('flex'))) {
            console.error(`"gap-" Tailwind utilities do not work on Safari unless its a Grid. gap was attempted on component
         "${compClassName}" using classes "${classNameFromProps}", try "space-x-2".`);
        }
        if (disableMount) {
            return null;
        }
        if (collapse) {
            return react_1.default.createElement(react_1.default.Fragment, null, props.children);
        }
        // ref isnt available on first render and thats intended.
        if (props.tooltip) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Tooltip_1.default, { popperProps: { placement: 'top' }, targetRef: tooltipTargetRef }, props.tooltip),
                react_1.default.createElement(FunctionalComponent, Object.assign({}, newProps))));
        }
        if (wrapsHref && href) {
            return (react_1.default.createElement(A_1.default, { href: href, shallow: props.shallow, internal: true },
                react_1.default.createElement(FunctionalComponent, Object.assign({}, newProps))));
        }
        if (collapseInModal) {
            return (react_1.default.createElement(ModalPageCollapse_1.default, { collapseInModal: collapseInModal },
                react_1.default.createElement(FunctionalComponent, Object.assign({}, newProps))));
        }
        return react_1.default.createElement(FunctionalComponent, Object.assign({}, newProps));
    });
    /*
    * This provides an accessor for parent components to easily determine what children are being rendered with it.
    */
    // @ts-ignore
    NewComponent.displayName = compClassName;
    return NewComponent;
}
exports.default = withJourney;
